export function formatNotificationTime(ts: number): string {
  if (!Number.isFinite(ts)) return "--:--:--";

  const date = new Date(ts * 1000);
  if (!Number.isFinite(date.getTime())) return "--:--:--";

  return [date.getHours(), date.getMinutes(), date.getSeconds()]
    .map((part) => String(part).padStart(2, "0"))
    .join(":");
}

/**
 * 「复制通知」按钮用的最小字段结构。
 *
 * 只声明本函数需要的字段（而非依赖 `NotificationGroup` 完整类型），
 * 避免 utils 层反向依赖 composables 层。
 */
export interface NotificationCopySource {
  title: string;
  body: string;
  count: number;
  latestTs: number;
  actions?: Array<{ label: string; url: string }> | null;
}

/**
 * 构造通知卡片的可读复制文本：标题(计数) + 时间 + 正文 + actions 链接。
 * 各段之间以空值跳过，结尾不留多余空行。
 */
export function buildNotificationCopyText(group: NotificationCopySource): string {
  const lines: string[] = [];

  const titleLine = group.count > 1 ? `${group.title} (${group.count} 条状态更新)` : group.title;
  lines.push(titleLine);
  lines.push(formatNotificationTime(group.latestTs));

  if (group.body) {
    lines.push("");
    lines.push(group.body);
  }

  if (group.actions?.length) {
    lines.push("");
    for (const action of group.actions) {
      lines.push(`${action.label}: ${action.url}`);
    }
  }

  return lines.join("\n");
}
